export default "__VITE_ASSET__JN6atmc0__"